import type {Values} from '@wix/devzai-utils-common';
import {DoppeBusinessEntity} from './doppe-business-entity';
import {DoppeAutoBlogPostType} from './doppe-auto-blog-post-type';

export const DoppeBlogPostsExternalDataSourceType = {
    LatestWixBlogPosts: 'LatestWixBlogPosts',
    LatestHoppBlogPosts: 'LatestHoppBlogPosts',
    WixBlogPostsByCategories: 'WixBlogPostsByCategories',
    HoppBlogPostsByCategories: 'HoppBlogPostsByCategories',
} as const;

export type DoppeBlogPostsExternalDataSourceType = Values<typeof DoppeBlogPostsExternalDataSourceType>;

export type DoppeBlogPostsExternalDataSource =
    | {
    type: typeof DoppeBlogPostsExternalDataSourceType.LatestWixBlogPosts;
} | {
    type: typeof DoppeBlogPostsExternalDataSourceType.LatestHoppBlogPosts;
} | {
    type: typeof DoppeBlogPostsExternalDataSourceType.WixBlogPostsByCategories;
    categoryIds: string[];
} | {
    type: typeof DoppeBlogPostsExternalDataSourceType.HoppBlogPostsByCategories;
    categoryIds: string[];
};

export function doppeBlogPostsExternalDataSourceResolveBusinessEntityReferences(
    externalDataSource: DoppeBlogPostsExternalDataSource
) {
    switch (externalDataSource.type) {
        case DoppeBlogPostsExternalDataSourceType.LatestWixBlogPosts: {
            return {businessEntity: DoppeBusinessEntity.WixAutoBlogPostsList, id: DoppeAutoBlogPostType.Latest}
        }
        case DoppeBlogPostsExternalDataSourceType.LatestHoppBlogPosts: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoBlogPostsList, id: DoppeAutoBlogPostType.Latest}
        }
        case DoppeBlogPostsExternalDataSourceType.WixBlogPostsByCategories: {
            return {businessEntity: DoppeBusinessEntity.WixAutoBlogPostsList, id: DoppeAutoBlogPostType.Categories, metadata: {categoryIds: externalDataSource.categoryIds}}
        }
        case DoppeBlogPostsExternalDataSourceType.HoppBlogPostsByCategories: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoBlogPostsList, id: DoppeAutoBlogPostType.Categories, metadata: {categoryIds: externalDataSource.categoryIds}}
        }
    }
}